import React from 'react';
import { Platform, View } from 'react-native';

// ============================================================================
// BACKGROUND — flat, fixed page ground
// ----------------------------------------------------------------------------
// Exported as `FlowField` for backwards compatibility (every public/marketing
// route imports it under that name). Earlier versions drew a WebGL particle
// field, then a masked graph-paper grid. Both read as decoration rather than
// design, so the ground is now a single flat colour: the type, the product
// mocks, and the band sections carry the page.
//
// No animation, no rAF, no canvas — `prefers-reduced-motion` is honoured by
// construction.
// ============================================================================

export default function FlowField({ isDark = false }) {
  if (Platform.OS !== 'web') return null;

  return (
    <View
      pointerEvents="none"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        backgroundColor: isDark ? '#0A0B0A' : '#FAFAF8',
      }}
    />
  );
}
